import { lang } from '@umu/ukit-lang';
import { If, IfShow } from 'common/src/components';
import { Iconfont, Radio, Checkbox, UmuSelect, Tooltip, Tag } from '@umu/umu-design';
import React, { useState } from 'react';
import { classSet } from '@umu/umu-dom';
import { questionBasicOptionList, getScoreList, defaultWhiteOverlayInnerStyle } from '../../dataFlow';
interface IAdvanceOptionInfo {
    isRequire: string;
    range: [number, number];
    optionCount: number;
}
interface IProps {
    info: IAdvanceOptionInfo;
    multiple: boolean;
    isView?: boolean;
    isShowDefaultValue?: boolean;
    onChange: (info: IAdvanceOptionInfo) => void;
}

const tips = (
    <div className="question-radio-tooltip">
        <p className="label-title">{lang('可以设置讲师评价时数值型问题的默认数值。')}</p>
        <p className="label-desc">
            {lang('例：将默认值设置为 5，则讲师评价数值型问题时，答案默认为 5，讲师可以按照实际情况调整数值。')}
        </p>
    </div>
);
const AdvanceOption = (props: IProps) => {
    const {
        multiple,
        isView = false,
        isShowDefaultValue = false,
        info: { isRequire, range = [0, 0], optionCount = 0 },
        onChange,
    } = props;
    const optionLIst = getScoreList(optionCount);
    const [isShowDetail, setIsShowDetail] = useState(false);
    const [isRange, setIsRange] = useState(false);
    const renderTags = () => {
        const result: string[] = [];
        if (isRequire) {
            result.push(lang('必填'));
        }
        if (isRange) {
            result.push(`${range[0]}-${range[1]}`);
        }
        if (isShowDefaultValue) {
            result.push(`${lang('默认值')}: ${optionCount}`);
        }
        return result.map((item, index) => {
            return (
                <Tag key={index} color="gray" className="tag-split">
                    {item}
                </Tag>
            );
        });
    };
    const onRangeChange = (e: any) => {
        setIsRange(e.target.checked);
    };
    return (
        <div
            className={classSet({
                'advance-info': true,
                'option-border': !isView,
            })}
        >
            <div
                className={classSet({
                    'link-text': !isView,
                    'advance-info-heard': true,
                    'active': isShowDetail,
                })}
                onClick={() => setIsShowDetail(!isShowDetail)}
            >
                <Iconfont
                    type="DropDown"
                    className={classSet({
                        'view-hide': isView,
                        'option-drop-down-icon': true,
                        'active': isShowDetail,
                    })}
                />
                <span>
                    {lang('高级设置')} {isView ? ':' : ''}
                </span>
                {renderTags()}
            </div>
            <IfShow show={isShowDetail && !isView} className="advance-info-content">
                <div className="advance-info-rows advance-split">
                    <div className="rows-label">{lang('问题基本设置')}</div>
                    <Radio
                        list={questionBasicOptionList}
                        onChange={(value) => {
                            onChange({
                                ...props.info,
                                isRequire: value,
                            });
                        }}
                        active={isRequire}
                    />
                </div>
                <If condition={multiple}>
                    <div className="advance-info-rows advance-split">
                        <div className="rows-label">{lang('选项数量限制')}</div>
                        <div className="advance-info-rows">
                            <Checkbox checked={isRange} onChange={onRangeChange} />
                            <span className="advance-col-split">{lang('最少')}</span>
                            <UmuSelect
                                expandConfig={{ disabled: !isRange }}
                                value={isRange ? String(range[0]) : ''}
                                width={80}
                                options={optionLIst}
                                onChange={(value) => {
                                    onChange({
                                        ...props.info,
                                        range: [Number(value), range[1]],
                                    });
                                }}
                            />
                            <span className="advance-col-split">{lang('最多')}</span>
                            <UmuSelect
                                expandConfig={{ disabled: !isRange }}
                                value={isRange ? String(range[1]) : ''}
                                width={80}
                                options={optionLIst}
                                onChange={(value) => {
                                    onChange({
                                        ...props.info,
                                        range: [range[0], Number(value)],
                                    });
                                }}
                            />
                        </div>
                    </div>
                </If>
                <If condition={isShowDefaultValue}>
                    <div className="advance-info-rows">
                        <div className="rows-label template-question-tooltip">
                            {lang('默认值设置')}
                            <Tooltip
                                title={tips}
                                placement="bottom"
                                hideArrow
                                overlayInnerStyle={defaultWhiteOverlayInnerStyle}
                            >
                                <Iconfont type="tips" className="tooltip-icon-tips" />
                            </Tooltip>
                        </div>
                        <UmuSelect width={80} options={optionLIst} />
                    </div>
                </If>
            </IfShow>
        </div>
    );
};
export { IAdvanceOptionInfo, AdvanceOption };
